var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginHeaderBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 179,
    viewBox: "0 0 375 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.431 153.054C212.163 146.832 135.139 115.445 0 153.564L3.72301e-05 0L375 1.63918e-05V173.967C374.993 173.967 374.986 173.968 374.98 173.971C374.94 173.982 374.85 174.015 374.709 174.067C370.692 175.541 325.351 192.17 228.689 153.564C228.331 153.421 227.911 153.25 227.431 153.054ZM375 179C374.866 177.19 374.68 174.102 374.98 173.971C374.99 173.968 374.996 173.967 375 173.967V179Z",
    fill: "#2046A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHeaderBg);
export default __webpack_public_path__ + "static/media/login_header_bg.0ac2874e30aeb7f73c676b38dccf8de7.svg";
export { ForwardRef as ReactComponent };